import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import AboutAbadiNews from "./sections/AboutAbadiNews";
import GlossyBottomNavigation from "./sections/GlossyBottomNavigation";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <AboutAbadiNews />
      <GlossyBottomNavigation />
      <Footer />
    </div>;
}